import axios from "axios";


export class ThumbNailsService{
    static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND || "/api/dkbackend"}`;

    static getALLThumbnails() {
        let dataURL = `${this.serverURL}/tumbs`;
        // console.log('dataURL.usuario');
        //  console.log(dataURL);
            return axios.get(dataURL);
           
    }
    
    static getThumbnail(thumbId){
        let dataURL = `${this.serverURL}/tumb/${thumbId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static getThumbnailVSL_Id(thumbId){
        let dataURL = `${this.serverURL}/tumb_vsl/${thumbId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static createThumbnail(control){
        let dataURL = `${this.serverURL}/control/`;
        // console.log('dataURL.control');
        // console.log(dataURL,control);
        return axios.post(dataURL,control);
    }
       

    static updateThumbnail(control, vslId){
        let dataURL = `${this.serverURL}/control/${vslId}`;
        return axios.put(dataURL, control)
    }

    static deleteThumbnail(controlId){
        let dataURL = `${this.serverURL}/control/${controlId}`;
        return axios.delete(dataURL);
    }

    
       


}